/**
 * @name App
 * @author Gabriel M. Guimarães | gabrielmg7
 * @description Componente principal da aplicação do totem - Versão limpa
 * @returns {JSX.Element} JSX do componente principal
 * @package src/App.tsx
 */

import QZTrayInitializer from "./components/QZTrayInitializer";
import { AppRouter } from "./router";

const App: React.FC = () => {
  return (
    <>
      <QZTrayInitializer />
      <AppRouter />
    </>
  );
};

export default App;
